import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AuthGuard} from './auth/keycloak-auth.guard';
import {AudioRedirectService} from './views/resolver/audio-redirect.service';
import {WelcomeComponent} from './views/public/container/welcome.component';
import {DataProcessingGuard} from './views/secured/views/modules/data-processing/guard/data-processing.guard';
import {NoAccessDataProcessingGuard} from './views/secured/views/modules/data-processing/guard/no-access-data-processing.guard';
import {InfoPageComponent} from '@shared/components/info-page/info-page.component';

const routes: Routes = [
    {
        path: '',
        children: [
            {
                path: '',
                redirectTo: 'public',
                pathMatch: 'full'
            },
            {
                path: 'public',
                loadChildren: () => import('./views/public/public.module').then(module => module.PublicModule)
            },
            {
                path: 'secured',
                loadChildren: () => import('./views/secured/secured.module').then(module => module.SecuredModule),
                canActivate: [AuthGuard, DataProcessingGuard]
            },
            {
                path: 'data-processing',
                loadChildren: () => import ('./views/secured/views/modules/data-processing/data-processing.module').then(module => module.DataProcessingModule),
                canActivate: [AuthGuard, NoAccessDataProcessingGuard]
            }
        ]
    },
    {
        path: 'audio',
        component: WelcomeComponent,
        resolve: {audioMode: AudioRedirectService}
    },
    {path: 'info', component: InfoPageComponent},
    {path: '**', redirectTo: 'info'}
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {useHash: true})],
    exports: [RouterModule]
})
export class AppRoutingModule {
}

